import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Server, Activity, AlertTriangle, HardDrive } from 'lucide-react';
import { services, systemTechInfos } from '../data/mockData';
import { StatCard } from '../components/ui/StatCard';
export function TechnicalDashboard() {
  const navigate = useNavigate();
  const activeSystems = services.filter(s => s.row_status === 'active');
  const totalSystems = activeSystems.length;
  return <div className="space-y-6" data-id="element-359">
      <div className="flex justify-between items-center" data-id="element-360">
        <div data-id="element-361">
          <h1 className="text-2xl font-bold text-slate-800" data-id="element-362">
            Technical Dashboard
          </h1>
          <p className="text-slate-500" data-id="element-363">
            System Health & Infrastructure Overview
          </p>
        </div>
        <div className="bg-emerald-100 text-emerald-800 px-4 py-2 rounded-lg font-medium flex items-center" data-id="element-364">
          <Activity className="w-4 h-4 mr-2" data-id="element-365" />
          {totalSystems} Systems Running
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-366">
        {activeSystems.map(service => {
        const techInfo = systemTechInfos[service.uuid] || {
          totalVm: 0,
          totalRunning: 0,
          totalDown: 0,
          totalContainer: 0,
          totalPod: 0,
          activePod: 0,
          alerts: []
        };
        const hasAlerts = techInfo.alerts.length > 0;
        return <div key={service.id} onClick={() => navigate(`/technical/${service.uuid}`)} className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 cursor-pointer hover:shadow-md hover:border-emerald-200 transition-all group" data-id="element-367">
              <div className="flex justify-between items-start mb-4" data-id="element-368">
                <div className="p-3 bg-slate-100 rounded-lg group-hover:bg-emerald-50 transition-colors" data-id="element-369">
                  <Server className="w-6 h-6 text-slate-600 group-hover:text-emerald-600" data-id="element-370" />
                </div>
                {hasAlerts && <span className="flex h-3 w-3 relative" data-id="element-371">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-372"></span>
                    <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" data-id="element-373"></span>
                  </span>}
              </div>

              <h3 className="text-lg font-bold text-slate-800 mb-1" data-id="element-374">
                {service.name_en}
              </h3>
              <p className="text-sm text-slate-500 mb-4" data-id="element-375">{service.name}</p>

              <div className="space-y-3" data-id="element-376">
                <div className="flex justify-between items-center text-sm" data-id="element-377">
                  <div className="flex items-center text-slate-600" data-id="element-378">
                    <HardDrive className="w-4 h-4 mr-2" data-id="element-379" /> VMs
                  </div>
                  <div className="font-medium" data-id="element-380">
                    <span className="text-emerald-600" data-id="element-381">
                      {techInfo.totalRunning}
                    </span>
                    <span className="text-slate-400" data-id="element-382">/</span>
                    <span data-id="element-383">{techInfo.totalVm}</span>
                  </div>
                </div>

                <div className="flex justify-between items-center text-sm" data-id="element-384">
                  <div className="flex items-center text-slate-600" data-id="element-385">
                    <div className="w-4 h-4 mr-2" data-id="element-386" /> Pods
                  </div>
                  <div className="font-medium" data-id="element-387">
                    <span className="text-emerald-600" data-id="element-388">
                      {techInfo.activePod}
                    </span>
                    <span className="text-slate-400" data-id="element-389">/</span>
                    <span data-id="element-390">{techInfo.totalPod}</span>
                  </div>
                </div>

                {techInfo.totalDown > 0 && <div className="mt-3 pt-3 border-t border-slate-100 flex items-center text-xs text-red-600 font-medium" data-id="element-391">
                    <AlertTriangle className="w-3 h-3 mr-1" data-id="element-392" />
                    {techInfo.totalDown} VM(s) Down
                  </div>}
              </div>
            </div>;
      })}
      </div>
    </div>;
}